import MyDocumentsTemplates from './MyDocumentsTemplates';

export default MyDocumentsTemplates;
